import { Injectable } from '@angular/core';
import { BonusMalusValues, MotorVehiclesToReplace } from '@app/salesfunnel/interfaces';
import { NewModal as ModalService } from 'outshared-lib';
import { BehaviorSubject, Observable } from 'rxjs';
import { BonusMalusModalComponent, BonusMalusModalData } from './bonus-malus-modal.component';

@Injectable({
    providedIn: 'root',
})
export class BonusMalusModalService {

    public bonusMalusSubject: BehaviorSubject<BonusMalusValues | null> = new BehaviorSubject(null);
    public bonusMalusValues$: Observable<BonusMalusValues | null> = this.bonusMalusSubject.asObservable();

    constructor(
        private modalService: ModalService,
    ) { }

    public openModal(motorVehiclesToReplace: MotorVehiclesToReplace): void {
        if (!motorVehiclesToReplace.purchased_product_addition?.note_deviation_no_claim_years_bonus_malus) {
            return;
        }

        const data: BonusMalusModalData = { data: motorVehiclesToReplace };

        this.modalService
            .open<BonusMalusModalComponent>(BonusMalusModalComponent, data)
            .afterClosed$()
            .subscribe();
    }
}
